import styled from '@emotion/styled';

import { endDirection } from 'app/styles/selectors/markup';
import BenefitCheckMarkIcon from 'app/features/newLanding/components/newProductComparison/icons/BenefitCheckMarkIcon';
import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmall } = breakpoints;

const S = {};

S.Benefit = styled.li`
  label: Benefit;

  color: var(--colors-scarpa-flow);
  display: flex;
  align-items: start;
`;

S.CheckMark = styled(BenefitCheckMarkIcon)`
  label: CheckMark;

  display: flex;
  flex: 0 0 1.5rem;
  margin-${endDirection}: 1rem;
`;

S.Title = styled.p`
  label: Title;

  padding-top: 0.0625rem;

  @media (${widthSmall}) {
    white-space: nowrap;
  }
`;

export default S;
